export const ROOT_IMG_PATH = "/assets/vending-cart/"
